// @flow

import type {ApplicationState} from '../../types'
import type {SessionState} from '../types'

export function getIdToken(appState: ApplicationState): ApplicationState {
  return appState
}

function _getIdToken(state: SessionState): SessionState {
  return state
}

getIdToken.internal = _getIdToken
